import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "activity-list" }
const _hoisted_2 = { class: "section-space-bottom spacing-x" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted",
  "data-testid": "page-info"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_8 = { class: "pull-right" }
const _hoisted_9 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_10 = {
  for: "auto-refresh",
  class: "pr-2"
}
const _hoisted_11 = {
  key: 1,
  class: "spacing-x"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "text-info"
}
const _hoisted_16 = {
  key: 1,
  class: "text-success"
}
const _hoisted_17 = {
  key: 2,
  class: "text-warning"
}
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "text-danger" }
const _hoisted_21 = { class: "card-content-full-width" }
const _hoisted_22 = { class: "table table-hover table-condensed activity-list-table" }
const _hoisted_23 = {
  key: 0,
  class: "running-executions"
}
const _hoisted_24 = ["onClick", "onMouseup"]
const _hoisted_25 = {
  key: 0,
  class: "eventicon"
}
const _hoisted_26 = ["value", "disabled"]
const _hoisted_27 = ["title"]
const _hoisted_28 = {
  key: 0,
  class: "fas fa-circle-notch fa-spin text-info"
}
const _hoisted_29 = {
  key: 1,
  class: "fas fa-clock text-muted"
}
const _hoisted_30 = {
  key: 2,
  class: "fas fa-layer-group text-muted"
}
const _hoisted_31 = ["data-execstate", "data-statusstring"]
const _hoisted_32 = { class: "right date" }
const _hoisted_33 = {
  key: 0,
  class: "spacing-x-2"
}
const _hoisted_34 = { class: "" }
const _hoisted_35 = {
  key: 0,
  class: "timerel text-muted"
}
const _hoisted_36 = {
  key: 1,
  class: "timerel text-muted"
}
const _hoisted_37 = {
  class: "dateStarted date",
  colspan: "2"
}
const _hoisted_38 = {
  class: "user text-right",
  style: {"white-space":"nowrap"}
}
const _hoisted_39 = {
  key: 1,
  class: "eventtitle job"
}
const _hoisted_40 = {
  key: 2,
  class: "activity-list__eventargs"
}
const _hoisted_41 = {
  key: 0,
  class: "activity-list__eventargs-string"
}
const _hoisted_42 = { class: "optkey" }
const _hoisted_43 = { class: "optvalue" }
const _hoisted_44 = {
  key: 3,
  class: "eventtitle adhoc",
  colspan: "2"
}
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = ["href"]
const _hoisted_47 = {
  colspan: "8",
  class: "text-center"
}
const _hoisted_48 = {
  key: 2,
  class: "history-executions"
}
const _hoisted_49 = ["onClick", "onMouseup"]
const _hoisted_50 = {
  key: 0,
  class: "eventicon"
}
const _hoisted_51 = ["value"]
const _hoisted_52 = ["title"]
const _hoisted_53 = ["data-execstate", "data-statusstring"]
const _hoisted_54 = { class: "date" }
const _hoisted_55 = {
  key: 0,
  class: "spacing-x-2"
}
const _hoisted_56 = { class: "timeabs" }
const _hoisted_57 = {
  key: 0,
  class: "timerel text-muted"
}
const _hoisted_58 = {
  key: 1,
  class: "timerel text-muted"
}
const _hoisted_59 = ["title"]
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "duration text-secondary" }
const _hoisted_63 = {
  key: 0,
  class: "duration"
}
const _hoisted_64 = {
  key: 1,
  class: "duration"
}
const _hoisted_65 = {
  class: "user text-right",
  style: {"white-space":"nowrap"}
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 2,
  class: "text-secondary"
}
const _hoisted_69 = {
  key: 3,
  class: "text-strong"
}
const _hoisted_70 = { key: 4 }
const _hoisted_71 = { class: "exec-status-text custom-status" }
const _hoisted_72 = { class: "activity-list__eventargs" }
const _hoisted_73 = {
  key: 0,
  class: "activity-list__eventargs-string"
}
const _hoisted_74 = { class: "text-right" }
const _hoisted_75 = ["href"]
const _hoisted_76 = {
  key: 0,
  class: "loading-area"
}
const _hoisted_77 = {
  key: 0,
  "data-testid": "no-data-message",
  class: "loading-text"
}
const _hoisted_78 = {
  key: 1,
  class: "loading-text"
}
const _hoisted_79 = {
  key: 2,
  class: "text-warning",
  "data-testid": "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_filter = _resolveComponent("activity-filter")!
  const _component_btn = _resolveComponent("btn")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_modal = _resolveComponent("modal")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_offset_pagination = _resolveComponent("offset-pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.pagination.total > 0 && _ctx.pagination.total > _ctx.pagination.max)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.pagination.offset + 1) + " - ", 1),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.pagination.offset + _ctx.reports.length), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-pulse" }, null, -1)
                ]))])),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("pagination.of")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: _ctx.activityHref,
        class: "link-quiet",
        "data-testid": "summary-count"
      }, [
        (_ctx.pagination.total >= 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["summary-count", {
            'text-strong': _ctx.pagination.total < 1,
            'text-info': _ctx.pagination.total > 0,
          }])
            }, _toDisplayString(_ctx.pagination.total), 3))
          : (!_ctx.loadError)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("i", { class: "fas fa-spinner fa-pulse" }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("execution", _ctx.pagination.total > 0 ? _ctx.pagination.total : 0)), 1)
      ], 8, _hoisted_6),
      (_ctx.showFilters)
        ? (_openBlock(), _createBlock(_component_activity_filter, {
            key: 1,
            modelValue: _ctx.query,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
            "event-bus": _ctx.eventBus,
            opts: _ctx.filterOpts,
            "data-testid": "activity-list-filter-button"
          }, null, 8, ["modelValue", "event-bus", "opts"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.runningOpts.allowAutoRefresh)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                id: "auto-refresh",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autorefresh) = $event)),
                type: "checkbox",
                "data-testid": "auto-refresh-checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.autorefresh]
              ]),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("Auto refresh")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.deleteExec && _ctx.pagination.total > 0 && _ctx.showBulkDelete)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              (_ctx.bulkEditMode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("bulk.selected.count")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.bulkSelectedIds.length), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "btn btn-default btn-xs",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.bulkEditSelectAll && _ctx.bulkEditSelectAll(...args)))
                    }, _toDisplayString(_ctx.$t("select.all")), 1),
                    _createElementVNode("span", {
                      class: "btn btn-default btn-xs",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showBulkEditCleanSelections = true))
                    }, _toDisplayString(_ctx.$t("select.none")), 1),
                    _createVNode(_component_btn, {
                      size: "xs",
                      type: "danger",
                      class: "btn-fill",
                      disabled: _ctx.bulkSelectedIds.length < 1,
                      "data-testid": "delete-selected-executions",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showBulkEditConfirm = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("delete.selected.executions")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createElementVNode("span", {
                      class: "btn btn-default btn-xs",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.bulkEditMode = false))
                    }, _toDisplayString(_ctx.$t("cancel.bulk.delete")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.auth.deleteExec && !_ctx.bulkEditMode)
                ? (_openBlock(), _createBlock(_component_btn, {
                    key: 1,
                    size: "xs",
                    type: "default",
                    "data-testid": "activity-list-bulk-delete",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.bulkEditMode = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("bulk.delete")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_modal, {
      id: "cleanselections",
      modelValue: _ctx.showBulkEditCleanSelections,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showBulkEditCleanSelections) = $event)),
      title: _ctx.$t('Clear bulk selection'),
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_btn, {
            "data-dismiss": "modal",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showBulkEditCleanSelections = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-default",
            "data-dismiss": "modal",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.bulkEditDeselectAll && _ctx.bulkEditDeselectAll(...args)))
          }, _toDisplayString(_ctx.$t("Only shown executions")), 1),
          _createElementVNode("button", {
            class: "btn btn-danger",
            "data-dismiss": "modal",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.bulkEditDeselectAllPages && _ctx.bulkEditDeselectAllPages(...args)))
          }, _toDisplayString(_ctx.$t("all")), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_i18n_t, {
          keypath: "clearselected.confirm.text",
          tag: "p"
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.bulkSelectedIds.length), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_modal, {
      id: "bulkexecdelete",
      ref: "bulkexecdeleteresult",
      modelValue: _ctx.showBulkEditConfirm,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showBulkEditConfirm) = $event)),
      title: _ctx.$t('Bulk Delete Executions'),
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_btn, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showBulkEditConfirm = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_btn, {
            type: "danger",
            "data-dismiss": "modal",
            "data-testid": "confirm-delete",
            onClick: _ctx.performBulkDelete
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Delete Selected")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_i18n_t, {
          keypath: "delete.confirm.text",
          tag: "p"
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.bulkSelectedIds.length), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("execution", _ctx.bulkSelectedIds.length)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_modal, {
      id: "bulkexecdeleteresult",
      modelValue: _ctx.showBulkEditResults,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showBulkEditResults) = $event)),
      title: _ctx.$t('Bulk Delete Executions: Results'),
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_btn, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showBulkEditResults = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.bulkEditProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("em", null, [
                _cache[22] || (_cache[22] = _createElementVNode("b", { class: "glyphicon glyphicon-time text-info" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Requesting bulk delete, please wait.")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.bulkEditProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.bulkEditResults && _ctx.bulkEditResults.requestCount > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createVNode(_component_i18n_t, {
                      keypath: "bulkresult.attempted.text",
                      tag: "p"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.bulkEditResults.requestCount), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bulkEditResults && _ctx.bulkEditResults.successCount > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                    _createVNode(_component_i18n_t, {
                      keypath: "bulkresult.success.text",
                      tag: "p"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.bulkEditResults.successCount), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bulkEditResults && _ctx.bulkEditResults.failedCount > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                    _createVNode(_component_i18n_t, {
                      keypath: "bulkresult.failed.text",
                      tag: "p"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.bulkEditResults.failedCount), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (
            _ctx.bulkEditResults &&
            _ctx.bulkEditResults.failures &&
            _ctx.bulkEditResults.failures.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulkEditResults.failures, (message, ndx) => {
                      return (_openBlock(), _createElementBlock("ul", { key: ndx }, [
                        _createElementVNode("li", null, _toDisplayString(message), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bulkEditError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.bulkEditError), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("table", _hoisted_22, [
        (_ctx.running && _ctx.running.executions && _ctx.running.executions.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.running.executions, (exec) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: exec.id,
                  class: _normalizeClass(["execution link activity_row autoclickable", { nowrunning: !exec.dateCompleted, [exec.status]: true }]),
                  onClick: ($event: any) => (_ctx.autoBulkEdit(exec)),
                  onMouseup: _withModifiers(($event: any) => (_ctx.middleClickRow(exec)), ["middle"])
                }, [
                  (_ctx.bulkEditMode)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.bulkSelectedIds) = $event)),
                          type: "checkbox",
                          name: "bulk_edit",
                          value: exec.id,
                          disabled: 
                  exec.status === 'running' ||
                  exec.status === 'scheduled' ||
                  exec.status === 'queued'
                ,
                          class: "_defaultInput",
                          "data-testid": "bulk-delete-checkbox"
                        }, null, 8, _hoisted_26), [
                          [_vModelCheckbox, _ctx.bulkSelectedIds]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", {
                    class: "eventicon",
                    title: _ctx.executionState(exec.status)
                  }, [
                    (exec.status === 'running')
                      ? (_openBlock(), _createElementBlock("b", _hoisted_28))
                      : (exec.status === 'scheduled')
                        ? (_openBlock(), _createElementBlock("b", _hoisted_29))
                        : (exec.status === 'queued')
                          ? (_openBlock(), _createElementBlock("b", _hoisted_30))
                          : (_openBlock(), _createElementBlock("b", {
                              key: 3,
                              class: "exec-status icon",
                              "data-execstate": _ctx.executionStateCss(exec.status),
                              "data-statusstring": exec.status
                            }, null, 8, _hoisted_31))
                  ], 8, _hoisted_27),
                  _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_32, [
                    (exec.dateStarted && exec.dateStarted.date)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                          _createElementVNode("i", _hoisted_34, _toDisplayString(_ctx.momentJobFormatDate(exec.dateStarted.date)), 1),
                          (_ctx.isRecentCalendarDate(exec.dateStarted.date))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_35, _toDisplayString(_ctx.momentCalendarFormat(exec.dateStarted.date)), 1))
                            : (_openBlock(), _createElementBlock("i", _hoisted_36, _toDisplayString(_ctx.momentFromNow(exec.dateStarted.date)), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ])), [
                    [
                      _directive_tooltip,
                      _ctx.runningStatusTooltip(exec),
                      void 0,
                      { bottom: true }
                    ]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_37, [
                    (exec.status === 'scheduled')
                      ? (_openBlock(), _createBlock(_component_progress_bar, {
                          key: 0,
                          "model-value": 100,
                          striped: "",
                          type: "default",
                          label: "",
                          "label-text": 
                  exec.dateStarted && exec.dateStarted.date
                    ? _ctx.$t('job.execution.starting.0', [
                        _ctx.runningStartedDisplay(exec.dateStarted.date),
                      ])
                    : ''
                
                        }, null, 8, ["label-text"]))
                      : (exec.status === 'queued')
                        ? (_openBlock(), _createBlock(_component_progress_bar, {
                            key: 1,
                            "model-value": 100,
                            striped: "",
                            type: "default",
                            label: "",
                            "label-text": _ctx.$t('job.execution.queued')
                          }, null, 8, ["label-text"]))
                        : (exec.job && exec.job.averageDuration)
                          ? (_openBlock(), _createBlock(_component_progress_bar, {
                              key: 2,
                              "model-value": _ctx.jobDurationPercentage(exec),
                              striped: "",
                              active: "",
                              type: "info",
                              label: "",
                              "min-width": ""
                            }, null, 8, ["model-value"]))
                          : (exec.dateStarted && exec.dateStarted.date)
                            ? (_openBlock(), _createBlock(_component_progress_bar, {
                                key: 3,
                                "model-value": 100,
                                striped: "",
                                active: "",
                                type: "info",
                                label: "",
                                "label-text": _ctx.$t('running')
                              }, null, 8, ["label-text"]))
                            : _createCommentVNode("", true)
                  ])), [
                    [_directive_tooltip, _ctx.runningStatusTooltip(exec)]
                  ]),
                  _createElementVNode("td", _hoisted_38, [
                    _createElementVNode("em", null, _toDisplayString(_ctx.$t("by")), 1),
                    _createTextVNode(" " + _toDisplayString(exec.user), 1)
                  ]),
                  (exec.job)
                    ? _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_39, [
                        _createTextVNode(_toDisplayString(exec.job.name), 1)
                      ])), [
                        [_directive_tooltip, 
                _ctx.purify(
                  exec.job.group ? exec.job.group + '/' + exec.job.name : '',
                )
              ]
                      ])
                    : _createCommentVNode("", true),
                  (exec.job)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                        (exec.job.options)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exec.job.options, (value, key) => {
                                return (_openBlock(), _createElementBlock("span", { key: key }, [
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(key), 1),
                                  _createElementVNode("code", _hoisted_43, _toDisplayString(value), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!exec.job)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(exec.description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_45, [
                    _createElementVNode("a", {
                      class: "link-quiet",
                      title: "View execution output",
                      href: exec.permalink,
                      "data-testid": "execution-link"
                    }, "#" + _toDisplayString(exec.id), 9, _hoisted_46)
                  ])
                ], 42, _hoisted_24))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.sincecount > 0)
          ? (_openBlock(), _createElementBlock("tbody", {
              key: 1,
              class: "since-count-data autoclickable",
              "data-testid": "since-count-data",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.$t("info.newexecutions.since.0", _ctx.sincecount)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.reports.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_48, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (rpt) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: rpt.id,
                  class: _normalizeClass(["link activity_row autoclickable", [
              `ali-${rpt.id}`,
              {
                succeed: rpt.status === 'succeeded',
                fail: rpt.status === 'failed',
                missed: rpt.status === 'missed',
                highlight: _ctx.highlightExecutionId == rpt.id,
                job: rpt.job,
                adhoc: !rpt.job,
              },
            ]]),
                  "data-testid": "report-row-item",
                  onClick: ($event: any) => (_ctx.autoBulkEdit(rpt)),
                  onMouseup: _withModifiers(($event: any) => (_ctx.middleClickRow(rpt)), ["middle"])
                }, [
                  (_ctx.bulkEditMode)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.bulkSelectedIds) = $event)),
                          type: "checkbox",
                          name: "bulk_edit",
                          value: rpt.id,
                          class: "_defaultInput",
                          "data-testid": "bulk-delete-checkbox"
                        }, null, 8, _hoisted_51), [
                          [_vModelCheckbox, _ctx.bulkSelectedIds]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", {
                    class: "eventicon",
                    title: _ctx.reportState(rpt)
                  }, [
                    _createElementVNode("b", {
                      class: "exec-status icon",
                      "data-execstate": _ctx.reportStateCss(rpt),
                      "data-statusstring": _ctx.reportState(rpt)
                    }, null, 8, _hoisted_53)
                  ], 8, _hoisted_52),
                  _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_54, [
                    (rpt.dateEnded && rpt.dateEnded.date)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.momentJobFormatDate(rpt.dateEnded.date)), 1),
                          (_ctx.isRecentCalendarDate(rpt.dateEnded.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.momentCalendarFormat(rpt.dateEnded.date)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.momentFromNow(rpt.dateEnded.date)), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ])), [
                    [
                      _directive_tooltip,
                      {
                text:
                  rpt.dateEnded && rpt.dateEnded.date
                    ? _ctx.$t(
                        rpt.status === 'missed'
                          ? 'info.missed.0.1'
                          : 'info.completed.0.1',
                        [
                          _ctx.jobCompletedISOFormat(rpt.dateEnded),
                          _ctx.jobCompletedFromNow(rpt.dateEnded),
                        ],
                      )
                    : '',
                viewport: `.ali-${rpt.id}`,
              },
                      void 0,
                      { bottom: true }
                    ]
                  ]),
                  _createElementVNode("td", {
                    class: "node-stats",
                    title: _ctx.$t('0.total', [rpt.node.total])
                  }, [
                    (rpt.node.failed > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(rpt.node.failed) + " " + _toDisplayString(_ctx.$t("failed")), 1))
                      : (rpt.node.succeeded > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(rpt.node.succeeded) + " " + _toDisplayString(_ctx.$t("ok")), 1))
                        : _createCommentVNode("", true)
                  ], 8, _hoisted_59),
                  _createElementVNode("td", _hoisted_62, [
                    (rpt.status === 'missed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, "missed"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.formatDurationMomentHumanize(rpt)), 1))
                  ]),
                  _createElementVNode("td", _hoisted_65, [
                    _createElementVNode("em", null, _toDisplayString(_ctx.$t("by")), 1),
                    _createTextVNode(" " + _toDisplayString(rpt.user), 1)
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass(["eventtitle", { job: rpt.job, adhoc: !rpt.job }])
                  }, [
                    (!rpt.jobDeleted && rpt.job)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_66, [
                          _createTextVNode(_toDisplayString(rpt.job.group
                    ? rpt.job.group + "/" + rpt.job.name
                    : rpt.job.name), 1)
                        ])), [
                          [_directive_tooltip, 
                  _ctx.purify(
                    rpt.job.group ? rpt.job.group + '/' + rpt.job.name : '',
                  )
                ]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(rpt.description), 1)),
                    (
                  _ctx.query.jobIdFilter &&
                  rpt.job &&
                  _ctx.query.jobIdFilter !== rpt.job.id &&
                  _ctx.query.jobIdFilter !== '!null'
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                          _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-arrow-circle-right-alt" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Referenced")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (rpt.jobDeleted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.$t("job.has.been.deleted.0", [""])), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isCustomReportStatus(rpt))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                          _createElementVNode("span", _hoisted_71, _toDisplayString(rpt.customStatus), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("td", _hoisted_72, [
                    (rpt.argstring)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(rpt.argstring), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_74, [
                    _createElementVNode("a", {
                      class: "link-quiet",
                      href: rpt.permalink,
                      onMouseup: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["middle","stop"]))
                    }, " #" + _toDisplayString(rpt.id), 41, _hoisted_75)
                  ])
                ], 42, _hoisted_49))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.reports.length < 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          (!_ctx.loading && !_ctx.loadError)
            ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.$t("results.empty.text")), 1))
            : _createCommentVNode("", true),
          (_ctx.loading && _ctx.lastDate < 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-spinner fa-pulse" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Loading...")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-error" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("error.message.0", [_ctx.loadError])), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_offset_pagination, {
      pagination: _ctx.pagination,
      disabled: _ctx.loading,
      "show-prefix": false,
      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changePageOffset($event)))
    }, null, 8, ["pagination", "disabled"])
  ]))
}